import { Loader2 } from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * The "Accept" sign-off confirmation. (The "Request changes" form lives in the
 * shared RequestChangesDialog, used by both the detail view and the board drag.)
 * Driven entirely by the `action` flag + callbacks, so it carries no state.
 */
export function DecisionDialogs({
  action,
  submitting,
  taskTitle,
  onClose,
  onAccept,
}: {
  action: null | "accept" | "request";
  submitting: boolean;
  taskTitle: string;
  onClose: () => void;
  onAccept: () => void;
}) {
  return (
    <AlertDialog
      open={action === "accept"}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Accepted</AlertDialogTitle>
          <AlertDialogDescription>
            Accept “{taskTitle}” as complete.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={submitting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onAccept}
            disabled={submitting}
            className="gap-2"
          >
            {submitting ? (
              <>
                <Loader2 className="size-4 animate-spin" />
                Accepting…
              </>
            ) : (
              "Accept"
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
